import React, { FC, useEffect, useState } from 'react'
import CheckboxListFacet from '../components/CheckboxListFacet'
import { BaseFacetProps } from '../types'
import { CategoryFacetConnector, CategoryFacetConnectorProps } from 'connectors/Facets'

type CategoryFacetProps = BaseFacetProps & CategoryFacetConnectorProps

const CategoryFacet: FC<CategoryFacetProps> = ({
  baseUrl,
  nextAppRoute,
  getInitialCategoryFacets,
}) => {
  const [initialCategoryFacets, setInitialCategoryFacets] = useState<ReadonlyArray<string>>([])

  useEffect(() => {
    if (getInitialCategoryFacets.length > initialCategoryFacets.length) {
      setInitialCategoryFacets(getInitialCategoryFacets)
    }
  }, [getInitialCategoryFacets])

  return (
    <CheckboxListFacet
      facetName='category'
      attributesList={initialCategoryFacets}
      baseUrl={baseUrl}
      nextAppRoute={nextAppRoute}
    />
  )
}

export default CategoryFacetConnector(CategoryFacet)
